import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
  setColorPalette();
};

// SuperTVGo: paletas de cores independentes do claro/escuro — cada uma é um
// bloco `.dark.theme-<nome>` em _next-colors.scss. Aplicar a classe também
// no claro é inofensivo: essas paletas só existem combinadas com .dark,
// então não fazem nada até o usuário estar no escuro.
export const COLOR_PALETTES = [
  'zapi',
  'blue-marine',
  'green-code',
  'purple-clean',
];

export const setColorPalette = () => {
  const selectedPalette =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_PALETTE) || 'default';
  COLOR_PALETTES.forEach(palette => {
    document.body.classList.toggle(
      `theme-${palette}`,
      selectedPalette === palette
    );
  });
};
